<template>
  <div class="mt-6">
    <v-btn x-large
      color="secondary"
      class="secondary--btn mr-5"
      elevation="0"
      v-if="continueAvailable"
      :disabled="!continueEnabled" 
      :loading="$attrs.inAction"
      @click="_continueButtonClick">
        {{ $let('ContinueButtonLabel') }}
    </v-btn>

    <v-btn x-large
      v-if="saveAvailable"
      color="secondary"
      class="secondary--btn mr-5"
      elevation="0"
      :loading="$attrs.inAction"
      @click="_saveButtonClick">
        {{ $let('SaveButtonLabel') }}
    </v-btn>

    <v-btn x-large outlined
      color="tertiary"
      class="tertiary--btn"
      elevation="0"
      v-if="backAvailable" 
      @click="_backButtonClick">
        {{ $let('BackButtonLabel') }}
    </v-btn>

  </div>
</template>

<script>

  export default {
    name: "StepperButtons",
    inheritAttrs: false,
    components: { },
    props: {
      continueAvailable: { type: Boolean, default: true },
      continueEnabled: { type: Boolean, default: true },
      saveAvailable: { type: Boolean, default: false },
      backAvailable: { type: Boolean, default: true },
    },
    emits: ["continueClick", "backClick", "saveClick"],
    data: () => ({ }),
    methods: {
      _continueButtonClick() {
        this.$emit("continueClick");
      },
      _backButtonClick() {
        this.$emit("backClick");
      }, 
      _saveButtonClick(confirm) {
        if (confirm) this.$emit("saveClick");
      }, 
    }
  }
</script>